import { Configs } from 'constants/configs'
import { useAuthContext } from 'context/authContext'
import { FC, useState } from 'react'
import { LuActivity, LuLogOut, LuPrinter } from 'react-icons/lu'
import { Spinner } from 'components/ui/States'

interface IAdminNavbar {
    onPressPrint: () => void
    isPrinting?: boolean
    logoUrl: string
    schoolName?: string
}

export const AdminNavbar: FC<IAdminNavbar> = ({ onPressPrint, isPrinting, logoUrl, schoolName }) => {
    const { logout } = useAuthContext()
    const [logoFailed, setLogoFailed] = useState(false)
    const showLogo = !!logoUrl && !logoFailed

    return (
        <header data-print-static className='sticky top-0 z-40 bg-surface shadow-nav'>
            <div className='mx-auto flex h-16 max-w-content items-center justify-between gap-3 px-4 sm:px-6 lg:px-8'>
                <div className='flex min-w-0 items-center gap-3'>
                    {showLogo
                        ? <img
                            src={`${Configs.baseUrl}${logoUrl}`}
                            alt={schoolName ? `${schoolName}校徽` : '學校標誌'}
                            onError={() => setLogoFailed(true)}
                            className='h-9 w-auto max-w-[96px] shrink-0 object-contain sm:h-11 sm:max-w-[140px]' />
                        : <span className='grid h-8 w-8 shrink-0 place-items-center rounded-lg bg-primary text-white'>
                            <LuActivity aria-hidden className='h-5 w-5' />
                        </span>}
                    <div className='hidden min-w-0 leading-tight min-[480px]:block'>
                        <p className='truncate text-[15px] font-semibold tracking-tight text-ink sm:text-[17px]'>Intelligent Playground</p>
                        {schoolName && <p className='truncate text-xs text-ink-faint'>{schoolName}</p>}
                    </div>
                </div>

                <div className='flex shrink-0 items-center gap-2'>
                    <button
                        type='button'
                        onClick={onPressPrint}
                        disabled={isPrinting}
                        aria-label='列印報告'
                        className='btn btn-secondary px-3 sm:px-4'>
                        {isPrinting ? <Spinner /> : <LuPrinter aria-hidden className='h-5 w-5' />}
                        <span className='hidden sm:inline'>{isPrinting ? '產生中…' : '列印報告'}</span>
                    </button>
                    <button
                        type='button'
                        onClick={logout}
                        aria-label='登出'
                        className='btn btn-ghost px-3'>
                        <LuLogOut aria-hidden className='h-5 w-5' />
                        <span className='hidden sm:inline'>登出</span>
                    </button>
                </div>
            </div>
        </header>
    )
}
